module.exports = __webpack_public_path__ + "img/1-15.1edaca04.jpg";